
import React from 'react';
import { Separator } from "@/components/ui/separator";
import PolicyCard from './components/policy/PolicyCard';
import GeneralPolicySection from './components/policy/GeneralPolicySection';
import FixedDepositPolicySection from './components/policy/FixedDepositPolicySection';
import LiquidFundsPolicySection from './components/policy/LiquidFundsPolicySection';
import { usePolicyManager } from './hooks/usePolicyManager';

const InvestmentPolicy = () => {
  const { policy, setPolicy, isEditing, toggleEditing, handleSavePolicy } = usePolicyManager();

  return (
    <div className="space-y-6">
      <PolicyCard
        title="Board Approved Investment Policy"
        description="Configure the parameters for investment in Fixed Deposits and Liquid Mutual Funds"
        isEditing={isEditing}
        onEditToggle={toggleEditing}
        onSave={handleSavePolicy}
      >
        <div className="space-y-8">
          {/* General policy settings */}
          <GeneralPolicySection 
            policy={policy} 
            setPolicy={setPolicy} 
            isEditing={isEditing} 
          />

          <Separator />

          {/* Fixed Deposit policy */}
          <FixedDepositPolicySection 
            policy={policy} 
            setPolicy={setPolicy} 
            isEditing={isEditing}
          />

          <Separator />

          {/* Liquid Mutual Funds policy */}
          <LiquidFundsPolicySection 
            policy={policy} 
            setPolicy={setPolicy} 
            isEditing={isEditing}
          />
        </div>
      </PolicyCard>
    </div>
  );
};

export default InvestmentPolicy;
